import { LineChart } from "@mui/x-charts"
import { METER_TYPE } from "config/const"
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material"
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import { findKeyByValue, findMeterQtyi18Key } from "config/functions";
import moment from "moment";
import CustomButton from "components/CustomButton";
import CustomCard from "components/CustomCard";

const ChartMonthOrYear = ({
  data,
  selectedMeter,
  setSelectedMeter,
  selectedMonthOrYear,
  setSelectedMonthOrYear
}) => {
  const theme = useTheme();
  const { bt } = useBizTypeTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const TYPES = [
    { value: "Year", name: "LAST_YEAR" },
    { value: "Month", name: "LAST_MONTH" },
  ]

  return (
    <CustomCard width='100%' justifyContent='center' border='1px solid #000'>
      <Stack
        direction={isMobile ? 'column' : 'row'}
        padding={1}
        spacing={2}
      >
        <FormControl>
          <InputLabel>{bt('SELECT_METER')}</InputLabel>
          <Select
            sx={{ width: isMobile ? 'auto' : 200 }}
            label={bt('SELECT_METER')}
            value={selectedMeter}
            size="small"
            onChange={(m) => setSelectedMeter(m.target.value)}
          >
            {data?.meters?.map((m, idx) => {
              return (
                <MenuItem key={idx} value={m}>
                  <Typography>{`${bt(findKeyByValue(METER_TYPE, m?.type))} (${m.name})`}</Typography>
                </MenuItem>
              )
            })}
          </Select>
        </FormControl>
      </Stack>

      <LineChart
        xAxis={[
          {
            scaleType: "point",
            data: Array.from({ length: selectedMeter?.maxYArry }, (_, index) => index + 1),
          },
        ]}
        yAxis={[{
          max: Math.ceil(Math.max(...selectedMeter?.consumptionThisMonth) / 10) * 10 + 50,
          min: Math.ceil(Math.min(...selectedMeter?.consumptionThisMonth) / 10) * 10 - 50
        }]}
        series={[
          {
            data: selectedMeter?.consumptionThisMonth,
            label: selectedMonthOrYear === "Year"
              ? `${moment().format('MMM YYYY')}`
              : moment().format('MMM'),

            valueFormatter: (n) =>
              (n === null ? '' : `${parseFloat(n).toFixed(2)} ${bt(findMeterQtyi18Key(selectedMeter?.type))}`),

            curve: "natural",
            showMark: isMobile ? false : true,
            markSize: isMobile ? 6 : 4,
            strokeWidth: isMobile ? 3 : 2,
          },
          {
            data: selectedMonthOrYear === "Year"
              ? selectedMeter?.consumptionThisMonthLastYear
              : selectedMeter?.consumptionLastMonth,

            label: selectedMonthOrYear === "Year"
              ? `${moment().subtract(1, "year").format('MMM YYYY')}`
              : moment().subtract(1, "month").format('MMM'),

            valueFormatter: (n) =>
              (n === null ? '' : `${parseFloat(n).toFixed(2)} ${bt(findMeterQtyi18Key(selectedMeter?.type))}`),

            curve: "natural",
            showMark: isMobile ? false : true,
            markSize: isMobile ? 6 : 4,
            strokeWidth: isMobile ? 3 : 2,
          },
        ]}
        style={{ width: '100%' }}
        slotProps={{ legend: { hidden: true } }}
        sx
        height={isMobile ? 200 : 350}
      />
      <Stack direction='row' spacing={2} padding={1}>
        {TYPES?.map((type, idx) => {
          return (
            <CustomButton
              key={idx}
              variant={type?.value === selectedMonthOrYear ? "contained" : "outlined"}
              title={bt(type?.name)}
              onClick={() => setSelectedMonthOrYear(type?.value)}
            />
          )
        })}
      </Stack>
    </CustomCard>
  )
}
export default ChartMonthOrYear